import {
  faAddressBook,
  faCheck,
  faEdit,
  // faClock
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

const AccommodationOrExperienceCardView = ({
  show = true,
  type,
  priority,
  imageSrc,
  propertyName,
  address,
  checkIn,
  checkOut,
  date,
  roomRatePlan,
  roomName,
  optionName,
  price,
  onRemove,
  onEdit,
  onSelect,
  selectedIndex,
  horizontal,
  notAvailable,
  modalComponent,
}) => {
  const [showModal, setShowModal] = useState(false);
  if (!show) return null;

  const handleTitleClick = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const cardStyles = {
    display: "flex",
    flexDirection: horizontal ? "row" : "column",
    border: "1px solid #ddd",
    width: "100%",
    height: "100%",
  };

  const imageStyles = {
    objectFit: "cover",
    height: "150px",
    width: "100%",
  };

  const imageContainerStyles = horizontal
    ? { width: "40%", marginRight: "1rem" }
    : {};

  const contentContainerStyles = horizontal
    ? { width: "60%", minHeight: 150, display: "flex", flexDirection: "column" }
    : {};

  return (
    <div className="col mb-3">
      <div className="d-flex justify-content-between mb-1">
        <span className="badge bg-primary">{type}</span>
        {priority && (
          <span className="badge bg-success">Priority {priority}</span>
        )}
      </div>
      <div className="card position-relative" style={cardStyles}>
        {notAvailable && (
          <div className="card-img-overlay d-flex justify-content-center align-items-center bg-danger bg-opacity-25 m-0">
            <p className="text-center h3 text-black fw-bold">Not Available</p>
          </div>
        )}
        <div style={imageContainerStyles}>
          <img src={imageSrc} alt={propertyName} style={imageStyles} />
        </div>
        <div
          style={contentContainerStyles}
          className="d-flex flex-column h-100"
        >
          <div className="card-body  p-1 d-flex flex-column justify-content-between">
            <div>
              <div
                className="card-title h6 fw-bold mb-1"
                style={{ cursor: modalComponent ? "pointer" : "default" }}
                onClick={modalComponent ? handleTitleClick : undefined}
              >
                {propertyName}
              </div>
              <small className="d-block fw-bold text-muted mb-1">
                {address}
              </small>
              {checkIn && (
                <small className="d-block fw-bold">
                  <span className="text-muted">Check In:</span>{" "}
                  <span className="fw-bold">{checkIn}</span>
                </small>
              )}
              {checkOut && (
                <small className="d-block fw-bold">
                  <span className="text-muted">Check Out:</span>{" "}
                  <span className="fw-bold"> {checkOut}</span>
                </small>
              )}
              {date && (
                <small className="d-block fw-bold">
                  <span className="text-muted">Date:</span>{" "}
                  <span className="fw-bold">{date}</span>
                </small>
              )}
              {/* <div className="border-bottom">
            <small className="d-flex align-items-center text-wrap mb-1">
              <FontAwesomeIcon
                icon={faClock}
                className="holidaySprite hotelCardCalendar"
              />
              {date}
            </small>
          </div> */}
              {roomRatePlan &&
                roomRatePlan.map(
                  (
                    { room_name, rate_plan_name, adult_count, child_count },
                    roomPlanIndex
                  ) => (
                    <div key={`room-rate=plan-${roomPlanIndex}`}>
                      <p className="fw-bold mb-1">{room_name}</p>
                      <small className="d-block text-wrap">
                        <FontAwesomeIcon
                          icon={faAddressBook}
                          className="holidaySprite hotelCardCalendar"
                        />
                        {` ${rate_plan_name}${
                          adult_count ? `, Adult ${adult_count}` : ""
                        }${child_count ? ` Child ${child_count}` : ""}`}
                      </small>
                    </div>
                  )
                )}
              {roomName && <p className="fw-bold mb-1">{roomName}</p>}
              {optionName && <p className="fw-bold mb-1">{optionName}</p>}
            </div>
          </div>
          {(price || onRemove || onEdit || onSelect) && (
            <div className="card-footer mt-auto">
              <div className="d-flex align-items-center justify-content-between">
                <p className="card-text h6 fw-bold mb-0">
                  {price && (
                    <>
                      <span>€</span> {price}
                    </>
                  )}
                </p>
                {onRemove && (
                  <button
                    type="button"
                    className="btn btn-sm btn-danger"
                    onClick={onRemove}
                  >
                    Remove
                  </button>
                )}
                {onEdit && (
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={onEdit}
                  >
                    <FontAwesomeIcon
                      icon={faEdit}
                      className="holidaySprite hotelCardCalendar"
                    />{" "}
                    Change
                  </button>
                )}
                {onSelect && (
                  <>
                    {selectedIndex ? (
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        disabled
                      >
                        <FontAwesomeIcon
                          icon={faCheck}
                          className="holidaySprite hotelCardCalendar"
                        />{" "}
                        Selected
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={onSelect}
                      >
                        Select
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      {modalComponent && showModal && (
        <>
          <div
            className={`modal fade ${showModal ? "show d-block" : ""}`}
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                  />
                </div>
                <div className="modal-body pt-0">{modalComponent}</div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default AccommodationOrExperienceCardView;
